import { BCMSDate, useStateManager } from "bcms-react";
import React, { useRef } from "react";

import { SVGAsset } from "res";
import ChatItem from "../../classes/ChatItem";
import { ReceivedMessageWidget } from "../ChatMessageWidget";
import ChatNavigationWidget from "../ChatNavigationWidget";
import "./mobile.css";

import "./styles.css";

export default function ChatWidget(props) {
    const { data, ui, onMessageAdd, onMessageInput } = useStateManager();

    const textArea = useRef();
    const onChange = evt => onMessageInput(textArea.current.value);

    const sendBtn = evt => {
        if(!ui.sessionHasEnded) {
            const message = data.messageInput;
            const date = BCMSDate.init();
            const recieved = "Please hold, someone will be with your shortly. You are number 1 in line.";

            const userMessage = ChatItem.init(message, "sent", date, 0);
            const responseMessage = ChatItem.init(recieved, "received", date, 2);

            onMessageAdd(userMessage, true);
            setTimeout(() => onMessageAdd(responseMessage), 2000);
        }
    }


    return (
        <div className="chat-widget flex-container flex-vertical">
          <div className="set-height chat-widget-header flex-container flex-horizontal align-center">
            <div className="set-width icon-container">
              <SVGAsset id="XMessageBubbleIcon" />
            </div>
            <div className="flex-width">
              <h2>Chat</h2>
            </div>
          </div>
          <div className="flex-height chat-content-container flex-container flex-vertical">
            { ui.showInitialMessage && <ReceivedMessageWidget /> }
    
            { data.messages.map((message, index) => React.cloneElement(message.component, { key: index })) }
          </div>
          <div className="set-height chat-textarea-container">
            <textarea className="chat-text-area" placeholder="Enter your message here" value={ data.messageInput } ref={ textArea } onChange={ onChange } data-point="Chat_Enter_Message" />
            <div className={ `send-button flex-container flex-horizontal align-center clickable ${ ui.sessionHasEnded && "disable" }` } onClick={ sendBtn } data-point="Chat_Send_Message">
              <SVGAsset id="SendArrowIcon" />
            </div>
          </div>
          <div className="show-on-mobile">
                    <ChatNavigationWidget />
                </div>
        </div>
      );
}